import React from 'react';

import {
  useNavigate,
} from 'react-router-dom';

import { Card } from '../components/ui';

export default function CondizioniLocalizzazione() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 flex justify-center px-4 py-8">
      <Card className="w-full max-w-2xl p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-gray-800">
          Condizioni di utilizzo della localizzazione
        </h1>

        <div className="mt-5 space-y-4 text-sm text-gray-700 leading-relaxed">
          <p>
            Il sistema di timbratura utilizza
            i dati di localizzazione del
            dispositivo esclusivamente per
            associare una posizione alle
            registrazioni di presenza e,
            in particolare, alle timbrature
            automatiche relative alla pausa
            pranzo.
          </p>

          <p>
            Qualora l'utente non registri
            manualmente l'inizio della pausa,
            il sistema può registrare
            automaticamente una timbratura
            alle <strong>13:00</strong>.
            Qualora non venga registrata
            manualmente la fine della pausa,
            il sistema può registrare
            automaticamente una timbratura
            alle <strong>14:00</strong>.
          </p>

          <p>
            Per consentire questa funzione,
            l'applicazione può acquisire la
            posizione del dispositivo anche
            mentre l'applicazione si trova
            in background. La rilevazione
            viene limitata alle finestre
            temporali strettamente necessarie
            alla gestione delle timbrature
            automatiche e non è utilizzata
            per effettuare un tracciamento
            continuativo della posizione
            durante l'intera giornata.
          </p>

          <p>
            Per ogni rilevazione possono
            essere trattati latitudine,
            longitudine, precisione della
            posizione, data e ora della
            rilevazione e identificativo
            dell'utente interessato.
          </p>

          <p>
            I campioni temporanei utilizzati
            per individuare la posizione
            relativa alla timbratura vengono
            eliminati una volta decorso il
            periodo tecnico previsto dal
            sistema. La posizione associata
            alla timbratura viene conservata
            insieme ai dati di presenza per
            il periodo necessario alla
            gestione del rapporto di lavoro
            e agli eventuali obblighi
            amministrativi e di legge
            applicabili.
          </p>

          <p>
            L'accesso ai dati è consentito
            esclusivamente ai soggetti
            autorizzati nell'ambito delle
            rispettive funzioni aziendali.
            Le coordinate non vengono
            utilizzate per finalità estranee
            alla gestione delle presenze
            descritta in questa informativa.
          </p>

          <p>
            Nel caso in cui il dispositivo
            non riesca a fornire una posizione
            valida al momento della timbratura
            automatica, la registrazione può
            essere identificata nel sistema
            come timbratura senza posizione,
            affinché tale circostanza sia
            chiaramente visibile ai soggetti
            autorizzati.
          </p>

          <p>
            L'accettazione viene registrata
            insieme alla data, all'ora e alla
            versione delle presenti
            condizioni, in modo da poter
            documentare l'informativa
            presentata all'utente.
          </p>
        </div>

        <button
          type="button"
          onClick={() =>
            navigate(
              '/consenso-localizzazione'
            )
          }
          className="mt-6 px-4 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm font-medium hover:bg-gray-200"
        >
          ← Torna al consenso
        </button>
      </Card>
    </div>
  );
}